import { buildDownloadUrl } from '../../api';
import type { FileMetadata } from '../../types';

interface Props {
  token: string;
  metadata: FileMetadata;
}

// Binary files aren't rendered inline — the viewer shows a short
// "unknown format" card with a download button. The header bar in
// ViewerFrame already has a download link, but we repeat it here so
// it's the primary call-to-action when binary preview is the only
// thing on screen.
export function BinaryView({ token, metadata }: Props) {
  const downloadUrl = buildDownloadUrl(token);
  return (
    <div className="mx-auto flex max-w-md flex-col items-center rounded-2xl border border-panel bg-panel/60 p-8 text-center">
      <svg
        className="mb-4 h-12 w-12 text-muted"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.5}
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5A3.375 3.375 0 0010.125 2.25H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
        />
      </svg>
      <h2 className="mb-1 text-lg font-semibold text-panelFg">Preview not available</h2>
      <p className="mb-5 text-sm text-muted">
        This file type ({metadata.content_type || 'unknown'}) can't be rendered in the browser.
      </p>
      <a
        href={downloadUrl}
        download={metadata.filename}
        className="rounded-lg bg-accent/20 px-5 py-2 text-sm font-medium text-accent hover:bg-accent/30"
      >
        Download {metadata.filename}
      </a>
    </div>
  );
}
